import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Select, message, Spin } from 'antd';
import "./index.css";
import { makeRequest } from '../../services/api';
import $ from 'jquery';
import tram from "../../images/tram.png"
import g_tram from "../../images/g_tram.png"
import tram_n from "../../images/tram_n.png"

const google = window.google;
let map, marker, geocoder;

const initializeMap = (lat, lan) => {
    if (!lat) lat = -37.8453709;
    if (!lan) lan = 144.9521104;
    let mapOptions = {
        zoom: 18,
        center: {
            lat,
            lng: lan,
        },
    };

    geocoder = new google.maps.Geocoder();
    map = new google.maps.Map(
        document.getElementById("mapForLatLong"),
        mapOptions
    );
}

export default function Map() {

    const { Option } = Select;
    const [state, setState] = useState({
        geofence: [],
        vehicles: [],
        showInfoWindow: false,
        markerArr: [],
        isLoading: true,
        selectedGeofence: {}
    });

    function onChange(value) {
        let selectedValue = JSON.parse(value);

        let markerArr = state.vehicles.filter((item) => {
            if (item && item.hasOwnProperty('vehicle_info') && item["vehicle_info"] !== null && item["vehicle_info"]["GeoFenceName"] && item["vehicle_info"]["GeoFenceName"] !== null && item["vehicle_info"]["GeoFenceName"].toLowerCase().includes(selectedValue["GeoFenceName"].toLowerCase())) {
                return item;
            }
        });

        map.setCenter({
            lat: Number(selectedValue.Latitude),
            lng: Number(selectedValue.Longitude)
        })

        setState(prev => ({
            ...prev,
            markerArr: markerArr,
            selectedGeofence: selectedValue
        }));

        addMarkers(markerArr);

        const interval = setInterval(() => update5sec(selectedValue), 15000)
        return () => {
          clearInterval(interval);
        }
    }

    function onSearch(val) {
        console.log('search:', val);
    }

    const onCloseClick = () => {
        setState(prev => ({
            ...prev,
            showInfoWindow: false
        }))
    }

    useEffect(() => {
        loadMap()
        getGeoFence();
        // getVehicles();
    }, []);

    const update5sec = async (val) => {
        if (Object.keys(val).length > 0) {
            
            setState(prev => ({
                ...prev,
                showInfoWindow: false,
                markerArr: [],
                isLoading: true
            }));

            let vehicleList = state.vehicles;

            for (let vehicle of vehicleList) {
                vehicle["vehicle_info"] = await getVehicleInfo(vehicle.Name);
            }

            let markerArr = vehicleList.filter((item) => {
                if (item && item.hasOwnProperty('vehicle_info') && item["vehicle_info"] !== null && item["vehicle_info"]["GeoFenceName"] && item["vehicle_info"]["GeoFenceName"] !== null && item["vehicle_info"]["GeoFenceName"].toLowerCase().includes(val["GeoFenceName"].toLowerCase())) {
                    return item;
                }
            });

            setState(prev => ({
                ...prev,
                isLoading: false,
                markerArr: markerArr
            }))

            addMarkers(markerArr)
        }
    };

    const loadMap = () => {
        google.maps.event.addDomListener(
            window,
            "load",
            initializeMap(-37.8453709, 144.9521104)
        )
    };

    const addMarkers = (locations) => {
        for (let location of locations) {
            const icon = {
                url: tram_n, //tram,
                scaledSize: new google.maps.Size(30, 30),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 0)
            };

            let marker = new google.maps.Marker({
                position: {
                    lat: location.vehicle_info.Latitude,
                    lng: location.vehicle_info.Longitude,
                },
                map,
                draggable: false,
                icon: icon
            });

            let infowindow = new google.maps.InfoWindow({
                content: `<p class="mb-0">${location.Vechicle_Number}</p>`,
            });

            google.maps.event.addListener(marker, "click", function () {
                infowindow.open(map, marker);
            });
        }

    }

    const getGeoFence = async () => {
        try {
            let url = 'https://app-appdev-qa-verizon-gps.azurewebsites.net/api/geofences?code=sgPyBoKQEb5yiAinR3ZZzRkl42GaxvqS7Ak0zxZHJTPtU0/ewTe4zw==';

            const response = await makeRequest('get', url);

            if (response) {
                let geofenceResp = response;

                let vehicleList = geofenceResp.Vechicles;

                vehicleList = vehicleList.filter((item) => {
                    return item && item["Vechicle_Number"] !== null && item["Vechicle_Number"].toLowerCase().includes('shuttle')
                });

                for (let vehicle of vehicleList) {
                    vehicle["vehicle_info"] = await getVehicleInfo(vehicle.Vechicle_Number);
                }

                setState(prev => ({
                    ...prev,
                    geofence: geofenceResp.GeoFences,
                    vehicles: vehicleList,
                    isLoading: false
                }))

                return geofenceResp;
            }

        } catch (err) {
            return message.error(err.message)
        }
    }

    // const getVehicles = async () => {
    //     try {
    //         let url = 'https://app-appdev-qa-verizon-gps.azurewebsites.net/api/vehicles?code=2ABrmPEqwErXeVagcuTfLwVeqWZDL/drQ4wzqi2wilJj7izlT4KgXw==';

    //         const response = await makeRequest('get', url);

    //         if (response) {
    //             let vehicleList = JSON.parse(response);

    //             vehicleList = vehicleList.filter((item) => {
    //                 return item["Name"].toLowerCase().includes('shuttle')
    //             });

    //             for (let vehicle of vehicleList) {
    //                 vehicle["vehicle_info"] = await getVehicleInfo(vehicle.Name);
    //             }

    //             setState(prev => ({
    //                 ...prev,
    //                 vehicles: vehicleList,
    //                 isLoading: false
    //             }))

    //             return JSON.parse(response);
    //         }

    //     } catch (err) {
    //         return message.error(err.message)
    //     }
    // };

    const getVehicleInfo = async (vehicleId) => {
        try {
            let url = `https://app-appdev-qa-verizon-gps.azurewebsites.net/api/vehicles/location/${vehicleId}?code=yaBq27foup/uuhhMomtiNxuozOM/Urr9Gtu4TZyKLDrEsuIlcp3W2g==`;

            const response = await makeRequest('get', url);

            if (response) {
                setState(prev => ({
                    ...prev,
                    vehicles: JSON.parse(response)
                }))

                return JSON.parse(response);
            }

        } catch (err) {
            return message.error(err)
        }
    }

    return (
        <Container
            // fluid
            style={{ height: '100vh' }}
        >
            <Row className="mt-3">
                <Spin spinning={state.isLoading} tip="fetching vehicle locations...">
                    <h2>View Shuttle Route</h2>
                    <Col xs={12} md={12} xl={12} sm={12}>
                        <>
                            <Select
                                className='vehicle_dropdown mt-2'
                                showSearch
                                placeholder="Select a vehicle"
                                optionFilterProp="children"
                                onChange={onChange}
                                onSearch={onSearch}
                                allowClear
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {(state && state.hasOwnProperty('geofence') && state.geofence.length > 0) ? state.geofence.map((option, index) => <Option value={JSON.stringify(option)} >{option["GeoFenceName"]}</Option>) : ''}
                            </Select>
                        </>
                    </Col>

                    <Col xs={12} md={12} xl={12} sm={12}>
                        <div className='my-4 w-100'>
                            <div id="mapForLatLong"></div>
                        </div>
                    </Col>
                </Spin>
            </Row>
        </Container>
    );
}